// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2GnwY","list":"PatternAutocomplete_list__3B9hM"};